export default "__VITE_ASSET__540a2bb3__"